module.exports = __webpack_public_path__ + "fonts/Marianne-Regular.96357e2.woff2";